// extracted by mini-css-extract-plugin
export var beige = "theme-module--beige--92777";
export var white = "theme-module--white--77a6c";
export var wrapper = "theme-module--wrapper--06560";